import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
// import { ReverseRelevanceControl,RelevanceFormControl } from "../../../controls";
import { ReverseRelevanceControl } from "@cloudpivot/form/src/common/controls/reverse-relevance-control";
// import { ReverseQueryService }  from '../../../services'
import { ReverseQueryService } from '@cloudpivot/form/src/common/services';
let ReverseRelevanceList = class ReverseRelevanceList extends ReverseRelevanceControl {
    constructor() {
        super(...arguments);
        this.data = [];
    }
    get dataList() {
        const data = this.data.map((x) => x.data);
        return data;
    }
    onClick(item) {
        this.open(item);
    }
    updated() {
        const el = document.querySelector('.form-body');
        el.style.overflow = 'auto';
    }
    mounted() {
        const schemaCode = this.controlOpts.schemaCode || '';
        const listCode = this.controlOpts.listCode || '';
        const conditions = this.controlOpts.mobileConditions;
        const formControls = this.getFormControls();
        const c = this.control;
        const param = ReverseQueryService.getParams(conditions, formControls, c, this.findController);
        const queryParam = [];
        // if (param.length > 0) {
        ReverseQueryService.getListQueryConditions(schemaCode, listCode, param).then(res => {
            let queryConditions = res.conditions || [];
            // debugger;
            queryConditions = ReverseQueryService.formatQueryData(queryConditions);
            // queryConditions.map(qc => {
            //   let val =  qc.defaultValue;
            //   if (qc.propertyCode === SystemCodes.sequence_status && qc.defaultValue) {
            //     const status_en:string[] = [];
            //     if (qc.defaultValue) {
            //       const statusArr = qc.defaultValue.split(';');
            //       statusArr.forEach(s => {
            //         switch (s) {
            //           case FormStatusZh.DRAFT:
            //             status_en.push(FormStatusEn.DRAFT)
            //             break;
            //           case FormStatusZh.PROCESSING:
            //              status_en.push(FormStatusEn.PROCESSING)
            //             break;
            //           case FormStatusZh.CANCELLED:
            //             status_en.push(FormStatusEn.CANCELLED)
            //             break;
            //           case FormStatusZh.COMPLETED:
            //             status_en.push(FormStatusEn.COMPLETED)
            //             break;
            //           default:
            //             break;
            //         }
            //       });
            //       val = status_en.join(';');
            //     }
            //     // const status =  param.find(p => p.code === SystemCodes.sequence_status);
            //     // if (status) {
            //     //   val = [p.value];
            //     // }
            //   }
            //   return {
            //     code: qc.propertyCode,
            //     type: qc.propertyType,
            //     value: val
            //   }
            // })
            // param.forEach(p => {
            //   const queryItem = queryConditions.find(q => q.propertyCode === p.code);
            //   queryParam.push({
            //     code: p.code,
            //     type: queryItem.propertyType,
            //     value: p.value
            //   })
            // });
            this.getAll(queryConditions).then(data => (this.data = data));
        });
        // } else {
        //   this.getAll(queryParam).then(data => (this.data = data));
        // }
        // this.param = param;
    }
};
ReverseRelevanceList = tslib_1.__decorate([
    Component({
        name: "reverse-relevance-list",
        components: {}
    })
], ReverseRelevanceList);
export default ReverseRelevanceList;
